<script lang="ts">
		import { team } from "$lib/config/our-team";
		import {domain} from "$lib/config/system";

		export let author: 'ivan' | 'oleg' = 'oleg';
		
		let authorName: 'Ivan Shikht' | 'Oleg Maykher' = author === 'oleg' ? 'Oleg Maykher' : 'Ivan Shikht';
		let person = team.filter(( person ) => authorName.includes( person.name ))[0];
		let position = author === 'oleg'
				? 'CEO at Exoft'
				: 'Co-founder at Exoft';
		const aboutAuthor:object = {
				ivan:
						'Co-founder & CTO at Exoft, drives innovation in tailored software solutions for diverse clients. His expertise and entrepreneurial spirit have shaped the company\'s success since 2013. Ivan\'s passion for technology empowers clients to excel, leveraging market trends for competitive advantage.',
				oleg:
						'CEO at Exoft, drives innovation in healthcare software, aiming to enhance patient outcomes and streamline industry processes. With 500+ global projects, he\'s a thought leader in leveraging tech for healthcare advancement.'
		}
</script>

<div class="container">
	<div class="block-container flex-row">
		<div class="author flex-row">
			<div class="author-icon">
				<img src="/team/{person.name.split(' ').join('')}.webp" alt="{person.name}">
				<div class="author-header">
					<div class="author-top flex-row">
						<h2 class="author-title">
							<a href="{domain}/author/{author}/">
								by {person.name}
							</a>
						</h2>
						
						<div class="author-links flex-row">
							<a href="{person.linked}" target="_blank" rel="noreferrer" aria-label="Connect with {person.name} on LinkedIn (opens in new tab)">
								<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M1.85938 3.71875C2.88628 3.71875 3.71875 2.88628 3.71875 1.85938C3.71875 0.832471 2.88628 0 1.85938 0C0.832471 0 0 0.832471 0 1.85938C0 2.88628 0.832471 3.71875 1.85938 3.71875ZM0 5.31261H3.80163V17.0001H0V5.31261ZM14.1567 5.44967C14.1433 5.44542 14.1301 5.44105 14.1168 5.43669C14.0904 5.42795 14.064 5.41921 14.0356 5.41142C13.9846 5.39973 13.9336 5.39017 13.8816 5.38167C13.6797 5.3413 13.4587 5.31261 13.1994 5.31261C10.9831 5.31261 9.57737 6.92442 9.11412 7.54705V5.31261H5.3125V17.0001H9.11412V10.6251C9.11412 10.6251 11.9871 6.62373 13.1994 9.56261V17.0001H17V9.11317C17 7.3473 15.7898 5.87573 14.1567 5.44967Z" fill="#BABABA"/>
								</svg>
							</a>
							
							<a href="mailto:{person.email}" class="author-mail" aria-label="Contact: {person.email} (opens mail client)">
								<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M15.3 3H1.7C0.765 3 0.0085 3.72422 0.0085 4.60938L0 14.2656C0 15.1508 0.765 15.875 1.7 15.875H15.3C16.235 15.875 17 15.1508 17 14.2656V4.60938C17 3.72422 16.235 3 15.3 3ZM15.3031 6.21875L8.50313 10.2422L1.70312 6.21875V4.60938L8.50313 8.63281L15.3031 4.60938V6.21875Z" fill="#BABABA"/>
								</svg>
							</a>
						</div>
					</div>
					
					<p class="author-position">
						{position}
					</p>
				</div>
			</div>
			
			<div class="author-about flex-column">
				<div class="author-top flex-row">
					<h2 class="author-title">
						<a href="{domain}/author/{author}/">
							by {person.name}
						</a>
					</h2>
					
					<div class="author-links flex-row">
						<a href="{person.linked}" target="_blank" rel="noreferrer" aria-label="Connect with {person.name} on LinkedIn (opens in new tab)">
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M1.85938 3.71875C2.88628 3.71875 3.71875 2.88628 3.71875 1.85938C3.71875 0.832471 2.88628 0 1.85938 0C0.832471 0 0 0.832471 0 1.85938C0 2.88628 0.832471 3.71875 1.85938 3.71875ZM0 5.31261H3.80163V17.0001H0V5.31261ZM14.1567 5.44967C14.1433 5.44542 14.1301 5.44105 14.1168 5.43669C14.0904 5.42795 14.064 5.41921 14.0356 5.41142C13.9846 5.39973 13.9336 5.39017 13.8816 5.38167C13.6797 5.3413 13.4587 5.31261 13.1994 5.31261C10.9831 5.31261 9.57737 6.92442 9.11412 7.54705V5.31261H5.3125V17.0001H9.11412V10.6251C9.11412 10.6251 11.9871 6.62373 13.1994 9.56261V17.0001H17V9.11317C17 7.3473 15.7898 5.87573 14.1567 5.44967Z" fill="#BABABA"/>
							</svg>
						</a>
						
						<a href="mailto:{person.email}" class="author-mail" aria-label="Contact: {person.email} (opens mail client)">
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M15.3 3H1.7C0.765 3 0.0085 3.72422 0.0085 4.60938L0 14.2656C0 15.1508 0.765 15.875 1.7 15.875H15.3C16.235 15.875 17 15.1508 17 14.2656V4.60938C17 3.72422 16.235 3 15.3 3ZM15.3031 6.21875L8.50313 10.2422L1.70312 6.21875V4.60938L8.50313 8.63281L15.3031 4.60938V6.21875Z" fill="#BABABA"/>
							</svg>
						</a>
					</div>
				</div>
				
				<p class="author-position">
					{position}
				</p>
				
				<p class="author-description">{aboutAuthor[author]}</p>
			</div>
		</div>
		
		<div class="rating-block">
			<div class="rating-wrapper">
				<div class="rating-part">
					<p class="text">Rate this article</p>
					<div class="rating-stars">
						<form class="rating">
							<div class="rating__stars">
								<input id="rating-1" class="rating__input rating__input-1" type="radio" name="rating" value="1">
								<input id="rating-2" class="rating__input rating__input-2" type="radio" name="rating" value="2">
								<input id="rating-3" class="rating__input rating__input-3" type="radio" name="rating" value="3">
								<input id="rating-4" class="rating__input rating__input-4" type="radio" name="rating" value="4">
								<input id="rating-5" class="rating__input rating__input-5" type="radio" name="rating" value="5">
								<label class="rating__label" for="rating-1">
									<svg class="rating__star" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
										<g transform="translate(16,16)">
											<circle class="rating__star-ring" fill="none" stroke="#000" stroke-width="16" r="8" transform="scale(0)" />
										</g>
										<g stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(16,16) rotate(180)">
												<polygon class="rating__star-stroke" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#BABABA" />
												<polygon class="rating__star-fill" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#000" />
											</g>
											<g transform="translate(16,16)" stroke-dasharray="12 12" stroke-dashoffset="12">
												<polyline class="rating__star-line" transform="rotate(0)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(72)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(144)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(216)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(288)" points="0 4,0 16" />
											</g>
										</g>
									</svg>
									<span class="rating__sr">1 star—Terrible</span>
								</label>
								<label class="rating__label" for="rating-2">
									<svg class="rating__star" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
										<g transform="translate(16,16)">
											<circle class="rating__star-ring" fill="none" stroke="#000" stroke-width="16" r="8" transform="scale(0)" />
										</g>
										<g stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(16,16) rotate(180)">
												<polygon class="rating__star-stroke" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#BABABA" />
												<polygon class="rating__star-fill" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#000" />
											</g>
											<g transform="translate(16,16)" stroke-dasharray="12 12" stroke-dashoffset="12">
												<polyline class="rating__star-line" transform="rotate(0)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(72)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(144)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(216)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(288)" points="0 4,0 16" />
											</g>
										</g>
									</svg>
									<span class="rating__sr">2 stars—Bad</span>
								</label>
								<label class="rating__label" for="rating-3">
									<svg class="rating__star" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
										<g transform="translate(16,16)">
											<circle class="rating__star-ring" fill="none" stroke="#000" stroke-width="16" r="8" transform="scale(0)" />
										</g>
										<g stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(16,16) rotate(180)">
												<polygon class="rating__star-stroke" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#BABABA" />
												<polygon class="rating__star-fill" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#000" />
											</g>
											<g transform="translate(16,16)" stroke-dasharray="12 12" stroke-dashoffset="12">
												<polyline class="rating__star-line" transform="rotate(0)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(72)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(144)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(216)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(288)" points="0 4,0 16" />
											</g>
										</g>
									</svg>
									<span class="rating__sr">3 stars—OK</span>
								</label>
								<label class="rating__label" for="rating-4">
									<svg class="rating__star" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
										<g transform="translate(16,16)">
											<circle class="rating__star-ring" fill="none" stroke="#000" stroke-width="16" r="8" transform="scale(0)" />
										</g>
										<g stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(16,16) rotate(180)">
												<polygon class="rating__star-stroke" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#BABABA" />
												<polygon class="rating__star-fill" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#000" />
											</g>
											<g transform="translate(16,16)" stroke-dasharray="12 12" stroke-dashoffset="12">
												<polyline class="rating__star-line" transform="rotate(0)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(72)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(144)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(216)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(288)" points="0 4,0 16" />
											</g>
										</g>
									</svg>
									<span class="rating__sr">4 stars—Good</span>
								</label>
								<label class="rating__label" for="rating-5">
									<svg class="rating__star" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
										<g transform="translate(16,16)">
											<circle class="rating__star-ring" fill="none" stroke="#000" stroke-width="16" r="8" transform="scale(0)" />
										</g>
										<g stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
											<g transform="translate(16,16) rotate(180)">
												<polygon class="rating__star-stroke" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#BABABA" />
												<polygon class="rating__star-fill" points="0,15 4.41,6.07 14.27,4.64 7.13,-2.32 8.82,-12.14 0,-7.5 -8.82,-12.14 -7.13,-2.32 -14.27,4.64 -4.41,6.07" fill="#000" />
											</g>
											<g transform="translate(16,16)" stroke-dasharray="12 12" stroke-dashoffset="12">
												<polyline class="rating__star-line" transform="rotate(0)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(72)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(144)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(216)" points="0 4,0 16" />
												<polyline class="rating__star-line" transform="rotate(288)" points="0 4,0 16" />
											</g>
										</g>
									</svg>
									<span class="rating__sr">5 stars—Excellent</span>
								</label>
							</div>
						</form>
					</div>
				</div>
				
				<div class="rating-part">
					<p class="text">Rate</p>
					<div class="rating-count">
						<span class="rating-current">5.0</span>
						<span class="rating-max">/5.0</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import '$styles/vars';

	.block-container {
		width: 100%;
		display: flex;
		gap: 24px;
		
		.author {
			display: flex;
			gap: 24px;
			padding: 26px 36px;
			border-radius: 12px;
			color: $main-black;
			background: $light-grey;
			
			&-header {
				display: none;
			}
			
			&-icon {
				img	{
					width: 125px;
					height: 125px;
				}
			}
			
			&-about {
				display: flex;
				align-items: start;
			}
			
			&-position {
			margin: 6px 0 0 ;
			}
			
			&-description {
				margin: 12px 0 0;
				line-height: 24px;
			}
			
			&-top {
				column-gap: 16px;
			}
			
			&-title {
				font-size: 18px;
				text-align: center;
				margin: 0;
				font-weight: 700;
				a {
					color: $main-black;
					&:hover {
						color: $green;
					}
				}
			}
			
			&-links {
				column-gap: 15px;
				a {
					&:hover {
						svg {
							transition: scale 0.2s, fill 0.2s;
						}
						:global(svg) {
							scale: 1.1;
						}
						:global(path) {
							fill: $green;
						}
					}
				}
			}
			
			&-mail {
				margin-top: 1px;
			}
		}
		
		.rating {
			&-block{
			}
			
			&-wrapper {
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;
				width: 300px;
				height: 100%;
			}
			
			&-current {
				color: $green;
				font-size: 42px;
				font-weight: 700;
			}
			&-max {
				color: $dark-grey;
				font-size: 28px;
				font-weight: 600;
			}
		}
	}
	
	$hue: 223;
	$starHue: 89;

	:root {
		--bg: #{hsl($hue,10%,90%)};
		--fg: #{hsl($hue,10%,10%)};
		--primary: #{hsl($hue,90%,55%)};
		--green: #{hsl($starHue,77%,40%)};
		--green-t: #{hsla($starHue,77%,40%,0)};
		--bezier: cubic-bezier(0.42,0,0.58,1);
		--trans-dur: 0.2s;
	}

	.rating {
		margin: auto;
		
		&-part {
			.text {
				margin: 0;
				font-size: 16px;
				font-weight: 400;
				line-height: 28px;
			}
		}
		&__stars {
			display: flex;
	  	margin-top: 4px;
			position: relative;
		}
		&__star {
			display: block;
			overflow: visible;
			pointer-events: none;
			width: 48px;
			height: 48px;

			&-ring,
			&-fill,
			&-line,
			&-stroke {
				animation-duration: 1s;
				animation-timing-function: ease-in-out;
				animation-fill-mode: forwards;
			}
			&-ring,
			&-fill,
			&-line {
				stroke: var(--green);
			}
			&-fill {
				fill: var(--green);
				transform: scale(0);
				transition:
								fill var(--trans-dur) var(--bezier),
								transform var(--trans-dur) var(--bezier);
			}
			&-line {
				stroke-dasharray: 12 13;
				stroke-dashoffset: -13;
			}
			&-stroke {
				stroke: hsl($hue,10%,80%);
				transition: stroke var(--trans-dur);
			}
		}
		&__label {
			font-size: calc(18px + (30 - 24) * (100vw - 320px) / (1280 - 320));
			cursor: pointer;
			padding: 0.125em;
		}
		&__input {
			position: absolute;
			-webkit-appearance: none;
			appearance: none;
		}
		
		// stars
		&__input-1:hover ~ &__label:first-of-type &__star-stroke,
		&__input-2:hover ~ &__label:nth-of-type(-n + 2) &__star-stroke,
		&__input-3:hover ~ &__label:nth-of-type(-n + 3) &__star-stroke,
		&__input-4:hover ~ &__label:nth-of-type(-n + 4) &__star-stroke,
		&__input-5:hover ~ &__label:nth-of-type(-n + 5) &__star-stroke {
			stroke: var(--green);
			transform: scale(1);
		}
		&__input-1:checked ~ &__label:first-of-type &__star-ring,
		&__input-2:checked ~ &__label:nth-of-type(-n + 2) &__star-ring,
		&__input-3:checked ~ &__label:nth-of-type(-n + 3) &__star-ring,
		&__input-4:checked ~ &__label:nth-of-type(-n + 4) &__star-ring,
		&__input-5:checked ~ &__label:nth-of-type(-n + 5) &__star-ring {
			animation-name: starRing;
		}
		&__input-1:checked ~ &__label:first-of-type &__star-stroke,
		&__input-2:checked ~ &__label:nth-of-type(-n + 2) &__star-stroke,
		&__input-3:checked ~ &__label:nth-of-type(-n + 3) &__star-stroke,
		&__input-4:checked ~ &__label:nth-of-type(-n + 4) &__star-stroke,
		&__input-5:checked ~ &__label:nth-of-type(-n + 5) &__star-stroke {
			animation-name: starStroke;
		}
		&__input-1:checked ~ &__label:first-of-type &__star-line,
		&__input-2:checked ~ &__label:nth-of-type(-n + 2) &__star-line,
		&__input-3:checked ~ &__label:nth-of-type(-n + 3) &__star-line,
		&__input-4:checked ~ &__label:nth-of-type(-n + 4) &__star-line,
		&__input-5:checked ~ &__label:nth-of-type(-n + 5) &__star-line {
			animation-name: starLine;
		}
		&__input-1:checked ~ &__label:first-of-type &__star-fill,
		&__input-2:checked ~ &__label:nth-of-type(-n + 2) &__star-fill,
		&__input-3:checked ~ &__label:nth-of-type(-n + 3) &__star-fill,
		&__input-4:checked ~ &__label:nth-of-type(-n + 4) &__star-fill,
		&__input-5:checked ~ &__label:nth-of-type(-n + 5) &__star-fill {
			animation-name: starFill;
		}
		&__input-1:not(:checked):hover ~ &__label:first-of-type &__star-fill,
		&__input-2:not(:checked):hover ~ &__label:nth-of-type(2) &__star-fill,
		&__input-3:not(:checked):hover ~ &__label:nth-of-type(3) &__star-fill,
		&__input-4:not(:checked):hover ~ &__label:nth-of-type(4) &__star-fill,
		&__input-5:not(:checked):hover ~ &__label:nth-of-type(5) &__star-fill {
			fill: var(--green-t);
		}
		// screen reader text
		&__sr {
			clip: rect(1px,1px,1px,1px);
			overflow: hidden;
			position: absolute;
			width: 1px;
			height: 1px;
		}
	}

	// Dark theme
	@media (prefers-color-scheme: dark) {
		:root {
			--bg: #{hsl($hue,10%,10%)};
			--fg: #{hsl($hue,10%,90%)};
		}
		.rating {
			margin: auto;

			&__star {
				&-stroke {
					stroke: #BABABA;
				}
			}
		}
	}

	@keyframes starFill {
		from,
		0% {
			animation-timing-function: ease-out;
			transform: scale(0.9);
		}
		50% {
			animation-timing-function: ease-in-out;
			transform: scale(1.1);
		}
		to {
			transform: scale(1);
		}
	}
	@keyframes starStroke {
		from {
			transform: scale(1);
		}
		20%,
		to {
			transform: scale(0);
		}
	}

	@media (max-width: $tablet-size) {
		.block-container {
			flex-direction: column;
			gap: 36px;
			.rating-wrapper {
				flex-direction: row;
				justify-content: space-between;
				width: unset;
			}
		}
	}
	@media (max-width: $portrait-phone-size) {
		.block-container {
	  	.author {
				flex-direction: column;
				padding: 24px 12px;
				&-top, &-position {
					display: none;
				}
				&-header {
					display: flex;
					flex-direction: column;
		  		.author-top {
						flex-wrap: wrap;
						.author-title {
							text-align: start;
						}
					}
					div {
						display: flex;
						.author-links {
							align-items: center;
						}
					}
		  		p {
						display: block;
						margin-top: 12px;
					}
				}
				&-icon {
					display: flex;
					flex-direction: row;
					column-gap: 12px;
					img {
						width: 103px;
						height: 103px;
					}
				}
			}
			.rating-wrapper {
				flex-direction: column;
				row-gap: 24px;
			}
		}
  }
</style>
